
import { defineComponent, ref, computed } from "vue";
import { consts, ITemplateSet } from "../services/Models";

export default defineComponent({
  name: "HorizontalListSelectFrame",
  components: {},
  props: {
    items: { type: Array },
    emptyItem: { type: Object },
    inPageCount: { type: Number },
  },
  setup(props, context) {
    const pageIndex = ref<number>(0);
    const getPageCount = () =>
      props.inPageCount ?? props.items?.length ?? consts.initialPageCount;
    const getMaxPage = () => {
      const v =
        (props.items?.length ?? 0) /
        (props.inPageCount ?? consts.initialPageCount);
      const mod = v % consts.modDenominator;
      const maxpage = Math.floor(v);
      if (mod == 0) {
        return maxpage - 1;
      }
      return maxpage;
    };

    const inPageItems = computed(() => {
      const pageCount = getPageCount();
      const startIndex = pageIndex.value * pageCount;
      const endIndex = startIndex + pageCount;
      var itemId = -1;
      const emptyBox = Array.from(Array(pageCount).keys()).map((_) => {
        // 端数件数表示時のID重複の警告回避のためIDを振りなおす
        var item = JSON.parse(JSON.stringify(props.emptyItem)) as ITemplateSet;
        item.id = itemId;
        itemId--;
        return item;
      });
      return props.items
        ?.slice(startIndex, endIndex)
        .concat(emptyBox)
        .slice(0, pageCount);
    });

    const next = () => {
      pageIndex.value = pageIndex.value + 1;
      if (getMaxPage() < pageIndex.value) {
        pageIndex.value = getMaxPage();
      }
      context.emit("update", inPageItems.value);
    };
    const prev = () => {
      pageIndex.value = pageIndex.value - 1;
      if (pageIndex.value < 0) {
        pageIndex.value = 0;
      }
      context.emit("update", inPageItems.value);
    };
    const canNext = computed(() => pageIndex.value < getMaxPage());
    const canPrev = computed(() => 0 < pageIndex.value);

    context.emit("update", inPageItems.value);

    return {
      inPageItems,
      next,
      canNext,
      prev,
      canPrev,
    };
  },
});
